import { toast } from 'react-toastify';
import { APICore } from '../../helpers/api/apiCore';
const api = new APICore();

export const getMenuListtAsync = async (groupId: string) => {
    try {
        const baseUrl = '/MenuPage/GroupId';

        const { data } = await api.get(`${baseUrl}/${groupId}`, null)
        return data.data
    }
    catch (e) {
        return { "message": e }
    };
}

export const getMenuTreeListAsync = async (groupId: string) => {
    try {
        const baseUrl = '/MenuPage/tree';
        const { data } = await api.get(`${baseUrl}/${groupId}`, null)       
        return data.data
    }
    catch (e) {
        return { "message": e }
    };
}

export const getMenuTreeFormListAsync = async (groupId: string) => {
    try {
        const baseUrl = '/MenuPage/treeForm';
        const { data } = await api.get(`${baseUrl}/${groupId}`, null)       
        return data.data
    }
    catch (e) {
        return { "message": e }
    };
}

export const getMenuFullTreeListAsync = async (groupId: string) => {
    try {
        const baseUrl = '/MenuPage/Fulltree';
        const { data } = await api.get(`${baseUrl}/${groupId}`, null)       
        return data.data
    }
    catch (e) {
        return { "message": e }
    };
}

export const getMenuTreeMenuListAsync = async (groupId: string) => {
    try {
        const baseUrl = '/MenuPage/treeMenu';
        const { data } = await api.get(`${baseUrl}/${groupId}`, null)        
        return data.data
    }
    catch (e) {
        return { "message": e }
    };
}

export const addMenuAsync = async (item: any) => {
    try {
        const baseUrl = '/MenuPage/Create2';
        const { data } = await api.create(`${baseUrl}`, item)        
        if (data.isSuccess) {
            toast(data.message != "" ? data.message : "عملیات با موفقیت انجام شد", { type: 'success', toastId: 'successId' })       
            return data.data
        }
        else {
            return { sanjabError: data }
        }
    }
    catch (e) {
        toast("خطایی در سیستم رخ داد", { type: 'error', toastId: 'errorId' });    
        return null;
    }
};

export const editMenuAsync = async (item: any) => {
    try {
        const baseUrl = '/MenuPage/Update2';
        const { data } = await api.update(`${baseUrl}`, item)
        if (data.isSuccess) {
            toast(data.message != "" ? data.message : "عملیات با موفقیت انجام شد", { type: 'success', toastId: 'successId' });      
            return data.data
        }
        else {
            return { sanjabError: data }            
        }
    }
    catch (e) {
        toast("خطایی در سیستم رخ داد", { type: 'error', toastId: 'errorId' });
        return null;
    }
};

export const deleteMenuAsync = async (payload: string) => {
    try {
        const baseUrl = '/MenuPage/Delete2';
        const data = await api.delete(`${baseUrl}/${payload}`)
        if (data?.data?.isSuccess) {
            toast(data.data.message != "" ? data.data.message  : "حذف با موفقیت انجام شد", { type: 'success', toastId: 'successDeleteId' });            
        }
        else {
            toast(data.data.message != "" ? data.data.message  : "عملیات حذف انجام نشد", { type: 'error', toastId: 'errorDeleteId' });            
        }
    }
    catch (e) {
        toast("عملیات حذف انجام نشد", { type: 'error', toastId: 'errorDeleteId' });
    }
};